import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { FeatherModule } from 'angular-feather';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-icon-label',
  templateUrl: './icon-label.component.html',
  styleUrls: ['./icon-label.component.scss'],
  imports: [FeatherModule, TranslatePipe],
})
export class IconLabelComponent {
  @Input() title = ``;
  @Input() icon = ``;
  @Input() iconclass = `text-gray-dark`;
  @Input() isCustomIcon = false;

  hidden: boolean | null = null;

  getSourceLocation(): string {
    return `./assets/img/icons/${this.icon}.svg`;
  }
}
